/**
 * PhotoIcon/index.js
 * desc: photo icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const PhotoIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="photo icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.photo.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg"><path d="M33.666 23.666v-20c0-1.833-1.5-3.333-3.333-3.333h-20A3.343 3.343 0 007 3.666v20C7 25.5 8.5 27 10.333 27h20c1.833 0 3.333-1.5 3.333-3.334zM15.333 17l3.383 4.516 4.95-6.183 6.667 8.333h-20l5-6.666zm-15 13.333V7h3.333v23.333H27v3.333H3.666a3.343 3.343 0 01-3.333-3.333z" /></svg>
    </IconButton>
);


export default PhotoIcon;
